import { Choices } from '@customTypes/Choices'
const prepareSuccessUrl = async (successUrl: string, choices: Choices): Promise<string> => {
  const { selectedBookableDateAndTime, treatmentBundleTypeReferenceId, preferredPractitionerReferenceIds } = choices
  return successUrl
    .replace('{treatmentDate}', selectedBookableDateAndTime.day || '')
    .replace('{treatmentTime}', encodeURIComponent(selectedBookableDateAndTime.time || ''))
    .replace('{treatment}', treatmentBundleTypeReferenceId || '')
    .replace('{practitioner}', preferredPractitionerReferenceIds[0] || '')
}

export default prepareSuccessUrl
